import * as stylex from "@stylexjs/stylex";
import {
  spacing,
  fonts,
  fontSizes,
  colors,
} from "@softmax/design-system/tokens.stylex";

export const styles = stylex.create({
  room: {
    height: {
      default: "calc(100svh - 65px)",
      "@media (min-width: 1024px)": {
        ":is(body:has([data-rail]) *)": "100svh",
      },
    },
    width: "100%",
    overflowY: "auto",
    scrollbarGutter: "stable",
  },
  inset: {
    boxSizing: "border-box",
    marginInline: "auto",
    width: "100%",
    maxWidth: 1200,
    paddingInline: {
      default: spacing.space24,
      "@media (min-width: 640px)": spacing.space32,
      "@media (min-width: 1024px)": {
        default: spacing.space64,
        ":is(body:has([data-rail]) *)": spacing.space32,
      },
    },
    paddingTop: { default: 40, "@media (min-width: 1024px)": 56 },
    paddingBottom: spacing.space32,
  },
  column: {
    display: "flex",
    flexDirection: "column",
    gap: spacing.space32,
    marginInline: "auto",
    width: "100%",
    maxWidth: 720,
  },
  heading: {
    margin: 0,
    fontFamily: fonts.sans,
    fontSize: fontSizes.reading,
    lineHeight: "22px",
    color: colors.muted,
    fontWeight: 400,
  },
  loading: {
    display: "flex",
    minHeight: "60vh",
    flexDirection: "column",
    gap: spacing.space12,
    alignItems: "center",
    justifyContent: "center",
  },
  copy: {
    margin: 0,
    fontFamily: fonts.sans,
    fontSize: fontSizes.reading,
    lineHeight: "22px",
    color: colors.muted,
  },
});
